import '../../styles/globals.css'
function FeedbackCustomer(){
    return (
        <section className="testimonials">
            <div className="container">
                <h2 className="section-title">O que nossos clientes dizem</h2>
                <div className="testimonials-grid">
                    <div className="testimonial-card">
                        <p className="testimonial-text">"Contratei o plano da Hapvida para minha família e não poderia estar mais satisfeita. Atendimento rápido e de qualidade em todas as especialidades que precisamos."</p>
                        <p className="testimonial-author">- Maria Silva, Fortaleza-CE</p>
                    </div>
                    <div className="testimonial-card">
                        <p className="testimonial-text">"Excelente custo-benefício. Tenho acesso a uma rede ampla de hospitais e clínicas sem pagar caro por isso. Recomendo a todos meus amigos."</p>
                        <p className="testimonial-author">- João Santos, Recife-PE</p>
                    </div>
                    <div className="testimonial-card">
                        <p className="testimonial-text">"Quando precisei de uma cirurgia de emergência, fui atendido rapidamente e com todo cuidado necessário. A Hapvida salvou minha vida!"</p>
                        <p className="testimonial-author">- Carlos Oliveira, Salvador-BA</p>
                    </div>
                </div>
            </div>
        </section>
    );
}

export default FeedbackCustomer;